import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'loading-container',
    template: require('./loading-container.template.html')
})
export class LoadingContainerComponent {
    @Input() loading: boolean = false;
    constructor() {

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/spinner/loading-container.component.ts